import BaseListPresenter from "../../../../base/BaseListPresenter";
import exportToCSV, { exportToExcel } from "../utils/export";
// import {
//   format,
//   startOfDay,
//   addHours,
//   addMinutes,
//   addDays,
//   parseISO,
// } from "date-fns";
// import { parseISO, startOfDay, endOfDay } from "date-fns";
import { parseISO, startOfDay, addDays, set, subHours } from "date-fns";

class ReportsPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase
  ) {
    super(view, findObjectUseCase, deleteObjectUseCase);
    this.findObjectUseCase = findObjectUseCase;
    this.countObjectUseCase = countObjectUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
    this.upsertUseCase = upsertUseCase;
  }

  init() {
    this.limit = 20;
    const user = this.view.getCurrentUser();
    const hasAdminRole = user?.roles?.some((role) => role.id === "Admin");
    const storeId = user?.storeAnalytic?.[0]?.id;
    this.where = hasAdminRole ? {} : { "storeId.id": { $eq: storeId } };
    // this.where = {};
    this.search = {};
    this.filter = {};
    this.filterDate = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { created: -1 };
    this.progress = true;
    this.reset();
  }

  async getObjects(where) {
    this.reset();
    await this.countObjects();
    await this.findObjects(where);
  }

  createQuery() {
    // if (!this.filterDate || Object.keys(this.filterDate).length === 0) {
    //   return null; // or return {} if you want to handle differently
    // }
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: {
        ...this.where,
        ...this.search,
        ...this.filter,
        ...this.filterDate,
      },
      include: this.include,
      count: true,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    // const keys = this.keys || this.view.getKeys() || [];
    // if (keys.length > 0) {
    //   query.keys = keys;
    // }
    return query;
  }

  async countObjects() {
    try {
      this.showProgress();
      const collection = this.view.getCollectionName();
      const query = this.createQuery();
      const { count } = await this.countObjectUseCase.execute(collection, {
        where: query.where,
      });
      this.count = count;
      this.view.setCount(this.count);
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
  }

  async findObjects(where) {
    if (!this.filterDate || Object.keys(this.filterDate).length === 0) {
      console.log("Skipped fetching — no filterDate applied");
      // this.view.setObjects(this.objects);
      // this.view.setCount(0);
      this.hideProgress();
      return;
    }
    const collection = where || this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      console.log("Variant", this.objects);
      this.view.setObjects(this.objects);
      this.view.setCount(this.count);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  // onChangeDate(where) {
  //   const { created } = where;

  //   if (!where.created || !where.created.$gte || !where.created.$lte) {
  //     this.filterDate = {};
  //     this.reset();
  //     this.getObjects();
  //     return;
  //   }

  //   if (created && created.$gte && created.$lte) {
  //     const startDate = addHours(startOfDay(parseISO(created.$gte)), 5);
  //     const endDate = addMinutes(
  //       addHours(addDays(startOfDay(parseISO(created.$lte)), 0), 4),
  //       59
  //     );

  //     const formattedStartDate = format(startDate, "yyyy-MM-dd HH:mm:ss.SSS");
  //     const formattedEndDate = format(endDate, "yyyy-MM-dd HH:mm:ss.SSS");

  //     this.filterDate = {
  //       created: {
  //         $gte: formattedStartDate,
  //         $lte: formattedEndDate,
  //       },
  //     };
  //   }
  //   console.log("This.filter", this.filterDate);
  //   this.getObjects();
  // }
  // onChangeDate(where) {
  //   const { created } = where;

  //   if (!where.created || !where.created.$gte || !where.created.$lte) {
  //     this.filterDate = {};
  //     this.reset();
  //     this.getObjects();
  //     return;
  //   }

  //   if (created && created.$gte && created.$lte) {
  //     const startDate = startOfDay(parseISO(created.$gte));
  //     const endDate = endOfDay(parseISO(created.$lte));

  //     this.filterDate = {
  //       created: {
  //         $gte: startDate.toISOString(),
  //         $lte: endDate.toISOString(),
  //       },
  //     };
  //   }

  //   console.log("This.filter", this.filterDate);
  //   this.getObjects();
  // }
  onChangeDate(where) {
    const { created } = where;

    if (!where.created || !where.created.$gte || !where.created.$lte) {
      this.filterDate = {};
      this.reset();
      this.getObjects();
      return;
    }

    // Parse input dates (treat them as calendar days)
    const startBase = startOfDay(parseISO(created.$gte)); // Day start (local calendar)
    const endBase = startOfDay(parseISO(created.$lte)); // Day start (local calendar)

    // PH window: 05:00 of start day → 04:59:59.999 of the NEXT day (PH time)
    const startPH = set(startBase, {
      hours: 5,
      minutes: 0,
      seconds: 0,
      milliseconds: 0,
    });
    const endPH = set(addDays(endBase, 1), {
      hours: 4,
      minutes: 59,
      seconds: 59,
      milliseconds: 999,
    });

    // Convert PH (+08:00) to UTC explicitly (avoid relying on machine TZ)
    const startUTC = subHours(startPH, 8);
    const endUTC = subHours(endPH, 8);

    this.filterDate = {
      created: {
        $gte: startUTC.toISOString(), // e.g., previous day 21:00:00.000Z
        $lte: endUTC.toISOString(), // e.g., same day 20:59:59.999Z
      },
    };

    console.log("This.filter", this.filterDate);
    this.getObjects();
  }

  onClickImport() {}
  onClickExport() {
    const logs = this.objects.map((log) => {
      const date = new Date(log.logDate);
      const formattedDate = `${date.toLocaleString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      })} at ${date
        .toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        })
        .toLowerCase()}`;

      return {
        fcProduct: log.fcProduct || "N/A",
        beginningInventory: log.beginningInventory,
        saleCount: log.saleCount,
        ending: log.ending,
        pCount: log.pCount,
        costOfGoods: log.costOfGoods,
        ideal: log.ideal,
        variant: log.variant,
      };
    });

    exportToExcel("FC_Variant_Exports", logs);
  }

  searchSubmit(where) {
    this.reset();
    // this.search = search;
    this.getObjects(where);
  }
}

export default ReportsPresenter;
